import { getErrorPayload } from '@application/common/helpers/api-helper';
import { createAsyncThunk } from '@reduxjs/toolkit';
import WorkOrderApi from '@infrastructure/workorder-api';
import { addSuccessNotification } from '../common/notificationSlice';
export const getAllJobCategoriesAsync = createAsyncThunk('Job/GetAllJobCategories', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllJobCategories();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrderNumberAsync = createAsyncThunk('workorder/WorkOrderNumber', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getWorkOrderNumber();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkshopLocationAsync = createAsyncThunk('workshoplocation', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getWorkshopLocation();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkOrderByIdAsync = createAsyncThunk('workorder/GetById', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getWorkOrderById(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrdersByIdAsync = createAsyncThunk('workorder/GetAllWorkOrdersById', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkOrdersById(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllObjectsAsync = createAsyncThunk('Object/GetAll', async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllObjects();
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getContactPersonsByIdAsync = createAsyncThunk('debtor/GetContactPersonsByDebitorId', async (debtorId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getContactPersonsById(debtorId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createWorkOrderAsync = createAsyncThunk('workorder/create', async (workorder, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.createWorkOrder(workorder);
        dispatch(addSuccessNotification('Werkopdracht succesvol aangemaakt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrderAsync = createAsyncThunk('workorder/getAllWorkOrder', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkOrder(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateWorkOrderAsync = createAsyncThunk('workorder/Update', async (workorder, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.updateWorkOrder(workorder.id, workorder);
        dispatch(addSuccessNotification('Werkopdracht succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllAttachmentsByWorkorderIdAsync = createAsyncThunk('workorder/GetAllAttachmentsByWorkOrderId', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllAttachmentsByWorkorderId(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const addAttachmentsByWorkorderIdAsync = createAsyncThunk('workorder/UploadWorkOrderAttachment', async (uploadedFile, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.addAttachmentsByWorkorderId(uploadedFile);
        dispatch(addSuccessNotification('Bestand succesvol geüpload'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteWorkOrderAttachmentAsync = createAsyncThunk('workorder/DeleteAttachmentById', async (attachmentId, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.deleteWorkOrderAttachment(attachmentId);
        dispatch(addSuccessNotification('Bijlage succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const saveWorkOrderNoteAsync = createAsyncThunk('workorder/SaveWorkOrderNote', async (note, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.saveWorkOrderNote(note);
        dispatch(addSuccessNotification('Notitie succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrderStatusAsync = createAsyncThunk('workorder/GetAllWorkOrderStatus', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkOrderStatus();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllActiveWorkOrderAsync = createAsyncThunk('workorder/GetAllActiveWorkOrder', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllActiveWorkOrder(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllProgressNotesByWorkOrderIdAsync = createAsyncThunk('workorder/getAllProgressNotesByWorkOrderId', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllProgressNotesByWorkOrderId(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const createProgressNotesByIdAsync = createAsyncThunk('workorder/saveProgressNotesById', async (note, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.saveProgressNotesById(note);
        dispatch(addSuccessNotification('Voortgangsnotitie succesvol toegevoegd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteProgressNotesByIdAsync = createAsyncThunk('workorder/deleteProgressNotesById', async (workOrderNotesDto, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.deleteProgressNotesById(workOrderNotesDto);
        dispatch(addSuccessNotification('Voortgangsnotitie succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateWorkorderToUrgentAsync = createAsyncThunk('workorder/UpdateWorkorderToUrgent', async (updateUrgent, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.updateWorkorderToUrgent(updateUrgent.id, updateUrgent);
        dispatch(addSuccessNotification(response.data));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getOrdersByWorkOrderIdAsync = createAsyncThunk('workorder/GetOrdersByWorkOrderId', async (workOrderId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getOrdersByWorkOrderId(workOrderId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const deleteWorkOrderByIdAsync = createAsyncThunk(`Order/Delete`, async (id, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.deleteWorkOrderById(id);
        dispatch(addSuccessNotification('Record succesvol verwijderd'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrdersOnMoveAsync = createAsyncThunk('workorder/WorkOrdersOnMove', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkOrdersOnMove(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateWorkOrderStatusById = createAsyncThunk('workorder/UpdateWorkOrderStatusById', async (request, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.updateWorkOrderStatusById(request);
        dispatch(addSuccessNotification('Status succesvol bijgewerkt'));
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateDeliveryNotePdfAsync = createAsyncThunk('workorder/GenerateDeliveryNotePdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateDeliveryNotePdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateOtherWerkbonPdfAsync = createAsyncThunk('workorder/GenerateOtherWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateOtherWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateMotorReductorWerkbonPdfAsync = createAsyncThunk('workorder/GenerateMotorReductorWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateMotorReductorWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generatePompWerkbonPdfAsync = createAsyncThunk('workorder/GeneratePompWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generatePompWerkbonPdfAsync(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateMotorWerkbonPdfAsync = createAsyncThunk('workorder/GenerateMotorWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateMotorWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateTrommelmotorWerkbonPdfAsync = createAsyncThunk('workorder/GenerateTrommelmotorWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateTrommelmotorWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateVentilatorWerkbonPdfAsync = createAsyncThunk('workorder/GenerateVentilatorWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateVentilatorWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateStandardWerkbonPdfAsync = createAsyncThunk('workorder/GenerateStandardWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateStandardWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllEmployeesByLocationIdAsync = createAsyncThunk('workorder/GetAllEmployeesByLocationId', async (locationId, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllEmployeesByLocation(locationId);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkshopLocationByCurrentEmployeeAsync = createAsyncThunk('workshoplocation/getAllWorkshopLocationByCurrentEmployee', async (_, { rejectWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkshopLocationByCurrentEmployee();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateTerplaatsWerkbonPdfAsync = createAsyncThunk('workorder/GenerateTerplaatsWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateTerplaatsWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const generateSealWerkbonPdfAsync = createAsyncThunk('workorder/GenerateSealWerkbonPdf', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.generateSealWerkbonPdf(request);
        return response;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrdersDetailsAsync = createAsyncThunk('workorder/WorkOrdersDetails', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await WorkOrderApi.getAllWorkOrdersDetails(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const updateModulePermissionsStatusAsync = createAsyncThunk('workorder/updateModulePermissionsStatus', async (moduleData, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
        const response = await WorkOrderApi.updateModulePermissionsStatus(moduleData);
        return fulfillWithValue(response.data);
    }
    catch (error) {
    }
});
